module.exports = __webpack_public_path__ + "41cdaa169a12283fe6a35bf324fcaa04.png";